import UsageTypeSelect from './UsageTypeSelect'
import React from 'react'
import MultiSelect from './MultiSelect'
import { IUsageType } from '@api/types'

interface MultiUsageTypeSelectProps {
  values: IUsageType[]
  onChange: (usageTypes: IUsageType[]) => void
  bookableOnly?: boolean
  allOptionEnable?: boolean
  filterable?: boolean
  skipTagIds?: string[]
}

export default function MultiUsageTypeSelect({
  values,
  onChange,
  bookableOnly,
  allOptionEnable,
  filterable,
  skipTagIds,
}: MultiUsageTypeSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }

  return (
    <MultiSelect
      title="Usage Types"
      values={values
        .filter((v) => (skipTagIds ? !skipTagIds.includes(v.id) : true))
        .map((v, i) => (
          <span key={v.id}>{v.displayName}</span>
        ))}
      select={
        <UsageTypeSelect
          bookableOnly={bookableOnly}
          multi
          itemDisabled={(item) => !!values.find(({ id }) => item.id === id)}
          onChange={(ut) =>
            values.find(({ id }) => id === ut.id)
              ? onChange(values.filter(({ id }) => id !== ut.id))
              : onChange([...values, ut])
          }
          value={null}
          btnText="Add"
          buttonProps={buttonProps}
          allOptionEnable={allOptionEnable}
          filterable={filterable}
        />
      }
      onRemove={(id) => onChange(values.filter((av) => av.id !== id))}
    />
  )
}
